import { useActivePractice } from '@witmetrics/data-store';
import type { NavigationKey } from '@/types';
import CommandPalette from '@/components/CommandPalette';
import { CompassIcon } from '@/icons';
import { LAB_OPTIONS, PRACTICE_OPTIONS } from './constants';

export type NavigationDialogProps = {
  onSelect: (shortcut: NavigationKey) => void;
  onClose: () => void;
};

export default function NavigationDialog({
  onSelect,
  onClose,
}: NavigationDialogProps) {
  const activePractice = useActivePractice();

  return (
    <CommandPalette
      icon={<CompassIcon size="1.125rem" />}
      title="Quick navigation"
      subtitle="Type or click a shortcut"
      items={activePractice ? PRACTICE_OPTIONS : LAB_OPTIONS}
      onSelect={onSelect}
      onClose={onClose}
    />
  );
}
